import { render, staticRenderFns } from "./HealthHistory.vue?vue&type=template&id=f0c331be&scoped=true"
import script from "./HealthHistory.vue?vue&type=script&lang=ts"
export * from "./HealthHistory.vue?vue&type=script&lang=ts"
import style0 from "./HealthHistory.vue?vue&type=style&index=0&id=f0c331be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c331be",
  null
  
)

export default component.exports